module.exports = __webpack_public_path__ + "static/TheVirtualEconomy_1612x692-0767a391abddeaed801a5b01cbe96432.png";